import { render, staticRenderFns } from "./AssetFgas.vue?vue&type=template&id=58a2fb05&"
import script from "./AssetFgas.vue?vue&type=script&lang=js&"
export * from "./AssetFgas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports